import React from "react";
import { Modal } from "antd";
import { scroller } from "react-scroll";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./RealTimeReportModal.scss";
import realTimeImage1 from "../../../../images/checkAssistant/real-time-1.png";
import realTimeImage2 from "../../../../images/checkAssistant/real-time-2.png";
import realTimeImage3 from "../../../../images/checkAssistant/real-time-3.png";
import realTimeImage4 from "../../../../images/checkAssistant/real-time-4.png";

/**
 * 即時報表推廣 Modal
 *
 * 當使用者滾動到 channel-performance-table 時自動彈出
 * 介紹圖靈即時數據分析報表功能
 * 包含多圖輪播展示
 */
const RealTimeReportModal = ({ visible, onClose }) => {
  const images = [
    realTimeImage1,
    realTimeImage2,
    realTimeImage3,
    realTimeImage4,
  ];
  const handleLearnMore = () => {
    // 先關閉 Modal
    onClose();

    // 滑動到聯絡表單
    setTimeout(() => {
      scroller.scrollTo("contact-form-snapshot", {
        duration: 500,
        smooth: true,
      });
    }, 300); // 等待 Modal 關閉動畫完成
  };

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
      width={600}
      className="real-time-report-modal"
      maskClosable={false}
    >
      <div className="real-time-report-content">
        <h2 className="modal-title">
          <span className="title-bar">丨</span>
          圖靈即時數據分析報表，比你想像更豐富
        </h2>

        <div className="modal-image">
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            navigation
            pagination={{ clickable: true }}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            loop={true}
            className="image-swiper"
          >
            {images.map((image, index) => (
              <SwiperSlide key={index}>
                <img src={image} alt={`即時數據分析報表 ${index + 1}`} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        <div className="modal-description">
          <ul>
            <li>GA4 延遲不再、廣告一次整合、決策即刻上線。</li>
            <li>即時視圖：關鍵指標「即時」到位，不再等 GA4 延遲</li>
            <li>一站整合：Google / Meta / LINE… 多平台統一口徑</li>
            <li>行動導向：異常告警＋一鍵下鑽，從數據到行動更快</li>
          </ul>
        </div>

        <div className="modal-footer">
          <button className="learn-more-btn" onClick={handleLearnMore}>
            了解即時報表
            <span className="arrow">→</span>
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default RealTimeReportModal;
